import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  videoThumbnail: {
    width: "100%",
    height: 200,
    objectFit: "cover",
    border: "none",
  },
  channelAvatar: {
    width: 48,
    height: 48,
    borderRadius: "50%",
  },
  videoInfo: {
    display: "flex",
    gap: theme.spacing.space8,
    alignItems: "center",
    paddingTop: theme.spacing.space12,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space4,
  },
  description: {
    display: "flex",
    justifyContent: "space-between",
  },
  descriptionContent: {
    maxWidth: "70%",
  },
}));
